/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import type { IPageAttrs } from 'flarum/common/components/Page';
import type Mithril from 'mithril';

export interface RedirectHomeAttrs extends IPageAttrs {}

export default class RedirectHome extends Component<RedirectHomeAttrs> {
	oninit(vnode: Mithril.Vnode<RedirectHomeAttrs, this>) {
		super.oninit(vnode);
		m.route.set(app.route('home'), null, { replace: true });
	}
	view(): Mithril.Children {
		return null;
	}
}
